var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_586_5331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.44 18.9229C16.7306 20.2259 14.6491 20.9478 12.5 20.9829C5.5 20.9829 1.5 12.9829 1.5 12.9829C2.74389 10.6648 4.46914 8.63952 6.56 7.04291M10.4 5.22291C11.0883 5.06179 11.7931 4.98125 12.5 4.98291C19.5 4.98291 23.5 12.9829 23.5 12.9829C22.893 14.1185 22.1691 15.1876 21.34 16.1729M14.62 15.1029C14.3454 15.3977 14.0141 15.6341 13.6462 15.798C13.2782 15.962 12.8809 16.0502 12.4781 16.0573C12.0753 16.0644 11.6752 15.9903 11.3016 15.8394C10.9281 15.6885 10.5887 15.4639 10.3038 15.1791C10.019 14.8942 9.79439 14.5549 9.64351 14.1813C9.49262 13.8077 9.41853 13.4076 9.42563 13.0048C9.43274 12.602 9.52091 12.2048 9.68488 11.8368C9.84884 11.4688 10.0853 11.1376 10.38 10.8629M1.5 1.98291L23.5 23.9829",
    stroke: "#858F98",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_586_5331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.98291)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeoff);
export default __webpack_public_path__ + "static/media/eyeoff.c88a1d14fb5af6a7bdecaa97ec75895b.svg";
export { ForwardRef as ReactComponent };